import Button from "../../component/button/Button";
import { userList } from "../../api/HttpApis";

export const UserData = async (page, perpage, searchQuery = "", filters = {}) => {
  const response = await userList({}, perpage, page, searchQuery, filters);
  const dataArray = Array.isArray(response?.data?.data)
    ? response.data.data
    : [];
  const totalCount = response?.data?.total || 0;

  const formattedData = dataArray.map((item) => ({
    id: item.id,
    name: item.name,
    email: item.email,
    user: item.user_type,
    updatedDate: item.data_added,
    emailVerified: item.email_verified,
    buttonText: "Edit",
    buttonText2: "Remove",
  }));

  return { data: formattedData, totalCount };
};

export const Columns = (handleEdit, handleDelete, deletingId, editingId) => {
  return [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "user", label: "userType" },
    { key: "updatedDate", label: "updatedDate" },
    {
      key: "buttonText",
      render: (item) => (
        <Button
          onClick={() => handleEdit(item.id)}
          loading={editingId === item.id}
        >
          {item.buttonText}
        </Button>
      ),
    },
    {
      key: "buttonText2",
      render: (item) => (
        <Button
          onClick={() => handleDelete(item.id)}
          loading={deletingId === item.id}
          disabled={deletingId === item.id}
        >
          {deletingId === item.id ? "Deleting..." : item.buttonText2}
        </Button>
      ),
    },
  ];
};
